import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { msalInstance } from "./msalInstance";
import { useDispatch } from "react-redux";
import { ssoLogin } from "../../Store/authSlice";

const AuthCallback = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

useEffect(() => {
  const handleAuth = async () => {
    try {
      const response = await msalInstance.handleRedirectPromise();

      console.log("MSAL Response:", response);

      if (!response || !response.account) {
        throw new Error("No response from MSAL");
      }

      const account = response.account;
      msalInstance.setActiveAccount(account);

      const idToken = response.idToken;

      console.log("🔥 ID Token:", idToken);

      const result = await dispatch(ssoLogin(idToken));

      if (result.meta.requestStatus === "fulfilled") {
        localStorage.setItem("isAuthenticated", "true");
        navigate("/");
      } else {
        throw new Error("Backend login failed");
      }

    } catch (error) {
      console.error("❌ Auth error:", error);
      navigate("/login");
    }
  };

  handleAuth();
}, []);

  return (
    <div style={{ textAlign: "center", marginTop: "100px" }}>
      Processing login...
    </div>
  );
};

export default AuthCallback;